import { DateTime } from "luxon";
import { DateHelper } from "../Common/DateHelper";

export class SessionStorageProvider implements ISessionStorageProvider
{
    public clear(): void
    {
        sessionStorage.clear();
    }
}

export interface ISessionStorageProvider
{
    clear(): void;
}
